export const projects = {
  title: "Project Management",
  form: {
    title: "Title",
    title_placeholder: "Enter the project title",
    description: "Description",
    description_placeholder: "Enter a description",
    startDate: "Start Date",
    endDate: "End Date",
    creating: "Creating...",
    updating: "Updating...",
    submit: "Create",
    update: "Update",
    create_success: "Project created successfully",
    create_error: "Error while creating project",
    update_success: "Project updated successfully",
    update_error: "Error while updating project",
    supplier: "Supplier",
    loading_suppliers: "Loading suppliers",
    select_supplier: "Select supplier",
    collaborator: "Collaborator",
    loading_users: "Loading collaborators",
    select_collaborator: "Select collaborator",
  },
  actions: {
    edit: "Edit",
    delete: "Delete",
  },
  header_title: "Project List",
  table: {
    createdAt: "Created At",
    startDate: "Start",
    endDate: "End",
  },
  create_form: {
    title: "New Project",
  },
};
